import { ExternalLink } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { PHOTO_CREDITS } from "@/lib/creditsPhotos";
import ArticleShell, { H2, P } from "@/components/site/ArticleShell";

export default function CreditsPhotosPage() {
  useSEO(
    "Crédits photos | Sculpteur Français",
    "Crédits et licences des photographies du site : œuvres, photographes, licences Creative Commons et domaine public, via Wikimedia Commons.",
    null,
    { noindex: true, robots: "noindex, follow" }
  );

  return (
    <ArticleShell
      testId="credits-photos-page"
      eyebrow="Transparence"
      titleLines={["Crédits photos"]}
      lead="Toutes les photographies du site sont hébergées sur sculpteur-francais.com. Voici leurs sources, leurs auteurs et leurs licences."
    >
      <H2>Photographies Wikimedia Commons</H2>
      <P>
        Les œuvres photographiées sont libres de droits : sculptures antiques,
        médiévales ou classiques, ou œuvres dont l'auteur est mort depuis plus de
        soixante-dix ans. Chaque photographie est créditée sous l'image concernée ;
        le détail complet figure ci-dessous, avec la licence et le lien vers la
        page source sur Wikimedia Commons.
      </P>

      <div className="divide-y divide-ink/10 border-y border-ink/10" data-testid="credits-photos-list">
        {PHOTO_CREDITS.map((c, i) => (
          <div key={c.creditUrl} className="grid gap-2 py-6 sm:grid-cols-12 sm:gap-6" data-testid={`credit-photo-row-${i}`}>
            <div className="sm:col-span-5">
              <p className="font-serif text-lg leading-snug text-ink">{c.sujet}</p>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.14em] text-smoke">{c.usage}</p>
            </div>
            <div className="sm:col-span-4">
              <p className="text-sm font-light text-body">{c.photographe}</p>
              <p className="mt-1 text-sm font-light text-body">{c.licence}</p>
            </div>
            <div className="sm:col-span-3 sm:text-right">
              <a
                href={c.creditUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`credit-photo-lien-${i}`}
                className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-bronze transition-colors hover:text-ink"
              >
                <span className="link-underline">Source Commons</span>
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </div>
          </div>
        ))}
      </div>

      <H2>Autres photographies</H2>
      <P>
        Les photographies d'ambiance restantes (ateliers, gestes, fonderie,
        musées) proviennent d'Unsplash et de Pexels, dont les licences autorisent
        l'utilisation libre sans attribution obligatoire ; elles sont elles aussi
        hébergées localement, au format WebP.
      </P>
    </ArticleShell>
  );
}
